import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { SavingsConverter } from '@/features/savings/logic/savings-converters/types'

const SECONDS_PER_DAY = 24 * 60 * 60

export interface CalculateProjectionsParams {
  timestamp: number // in seconds
  shares: NormalizedNumber
  savingsConverter: SavingsConverter
}
export function calculateOneYearProjection({
  timestamp,
  shares,
  savingsConverter,
}: CalculateProjectionsParams): NormalizedNumber {
  const base = savingsConverter.convertToAssets({ shares })
  return savingsConverter.predictAssetsAmount({ timestamp: timestamp + 365 * SECONDS_PER_DAY, shares }).minus(base)
}
